import i18n from "../i18n";

export function properDate(d) {
    const date = new Date(d);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export function properTime(d) {
    const date = new Date(d);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
}

export function properDateTime(d) {
    if (!d) {
        return i18n.t("helper.Date.never");
    }
    return i18n.t("helper.Date.dateTime", { date: properDate(d), time: properTime(d) });
}